<template>
  <div
    v-if="showFilter"
    class="filter-header"
  >
    <div
      class="filter-component"
    >
      <multi-select-component
        id="course_subscriptions_multi_select"
        v-model="courses"
        type="course"
        :include="{ 'subscribable_grouping_id': subscribableGroupingId }"
        :search-at-mounted="true"
        :placeholder="trans('courses.name')"
      />
    </div>
    <div class="filter-component">
      <button
        style="width: 100% !important;"
        :disabled="isExporting"
        class="btn btn-default pull-right"
        @click="exportSubscriptions"
      >
        <em class="fa fa-envelope-o" /><span class="hide-small-devs"> {{ trans('core.export') }}</span>
      </button>
    </div>

    <modal
      v-if="displayModal"
      :open="displayModal"
      :title="trans('core.export')"
      style="text-align:left; z-index: 9999999999"
      @close="displayModal = false"
    >
      <p> {{ trans('mail.export_sent') }} </p>

      <button
        type="button"
        class="btn btn-default pull-right"
        @click="displayModal = false"
      >
        {{ trans('core.close') }}
      </button>
      <br style="clear:both">
    </modal>
  </div>
</template>

<script>
import MultiSelectComponent from '@/employees/components/FormComponents/MultiSelectComponent'
import toast from '../../../services/toast'
import Modal from '@/employees/AttendanceList/components/Modal'

export default {
  name: 'CourseSubscriptionsFilter',

  components: { MultiSelectComponent, Modal },

  props: {
    subscribableGroupingId: {
      required: false,
      type: String,
      default: null,
    },
    value: {
      required: true,
      type: Object,
    },
    apiRoute: {
      required: true,
      type: String,
    },
    showFilter: {
      required: false,
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      displayModal: false,
      isExporting: false,
    }
  },

  computed: {
    courses: {
      get () {
        return this.value.courses
      },
      set (value) {
        this.emitInput('courses', value)
      },
    },

    exportApiRoute () {
      return this.apiRoute + '/export/xlsx?'
    },
  },

  methods: {
    emitInput (key, value) {
      const newValue = { ...this.value, [key]: value }

      this.$emit('input', newValue)
    },

    exportSubscriptions () {
      this.isExporting = true

      this.$store.dispatch('getSubscribablesMatrixExport', {
        apiRoute: this.exportApiRoute,
        queryParams: {
          filter: {
            ids: this.courses.map(course => parseInt(course.id)),
          },
        },
      }).then(() => {
        this.displayModal = true
      }).catch(() => {
        toast.error(Lang.get('errors.message.generalerror'))
      }).finally(() => {
        this.isExporting = false
      })
    },
  },
}
</script>

<style lang="scss">
.filter-header {
  display: flex;
  justify-content: space-between;
  gap: 5px;

  @media (max-width: 768px) {
    flex-direction: column
  }
  @media (min-width: 769px) {
    flex-direction: row
  }
}

.filter-component {
  flex: 1;
}

.multiselect__tags {
  border: 1px solid #ccc;
}

.el-input__inner {
  border: 1px solid #ccc;
}

.filter-component {
  input:focus {
    border-color: #ccc !important;
    box-shadow: none !important;
  }

  ::placeholder {
    color: lightgrey !important;
  }
}
</style>
